export * from './baBackTop.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baBackTop/index.ts